import { takeLatest, put, call } from 'redux-saga/effects';
import { adminLogin, refreshToken } from './../../network/auth';
import {
  USER_LOADING,
  INIT_ADMIN_LOGIN,
  TOKEN,
  TOKEN_REFRESH
} from './types';
import { FETCH_ERRORS, CLEAR_ERRORS } from '../error/types';
import { STATUS } from '../../config/constants/states';

function* loginAdminUser(action) {
  const payload = action.payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    const { data } = yield call(adminLogin, payload);
    yield put({ type: TOKEN, payload: data });
    yield put({ type: USER_LOADING, payload: true });
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    const { status, data } = e.response;
    yield put({
      type: FETCH_ERRORS, payload: {
        status: status || 500,
        message: data.message || 'Internal server error',
      }
    });
  }
};

function* tokenRefresh(action) {
  const payload = action.payload;
  try {
    const { data } = yield call(refreshToken, payload);
    yield put({ type: TOKEN, payload: data });
  } catch (e) {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: e.response.status || 500,
      }
    });
  }
}

function* watchFetchloginAdminUser() {
  yield takeLatest(INIT_ADMIN_LOGIN, loginAdminUser);
}

function* watchTokenRefresh() {
  yield takeLatest(TOKEN_REFRESH, tokenRefresh);
}

export default [
  watchFetchloginAdminUser(),
  watchTokenRefresh(),
];